export class User {
    Email: string
    Name: string
    Password: String
    Id: number
    Role: string

    constructor(Email: string) {
        this.Email = Email
    }
}

export class Transaction {
    TransactionId: number
    Amount: number
    Name: string
    Date: string // Change type from Date to string
    Id: number //Users Id
    Type: string
    DateString: string //M/D/Y

    constructor(name: string, amount: number, date: Date, userId: number) {
        this.Name = name
        this.Amount = amount
        this.Date = date.toISOString() // Convert Date object to string
        this.Id = userId
    }

    getFormattedDate() {
        return new Date(this.Date).toDateString() // Convert string back to Date object for formatting
    }
}

export class JwtToken {
    aud: string
    exp: Date
    iss: string
}

export class Analytics {
    MostCommonTransactionType: string
    Demographics: Array<SpendingDemographics> = []
    TransactionCount: number
    BiggestTransactionByAmount: BiggestTransaction
    amountOfMostCommonTransactionType: number
    savedAmount: number
}

export class SpendingDemographics {
    Type: string
    NumberOfTransaction: number
    MoneySpent: number

    constructor(Type: string, NumberOfTransaction: number, MoneySpent: number) {
        this.Type = Type
        this.NumberOfTransaction = NumberOfTransaction
        this.MoneySpent = MoneySpent
    }
}

export class BiggestTransaction {
    Type: string
    AmountSpent: number

    constructor(Type: string, AmountSpent: number) {
        this.Type = Type
        this.AmountSpent = AmountSpent
    }
}